<div class="modal">

  <div class="header">
    <div class="btn-accion" class="arrow" (click)="close()">
      <img src="/assets/images/icons/header/arrow-left.svg" alt="img"/>
    </div>

    <span class="title">{{title}}</span>

  </div>


  <div class="content">
    @if (type == 'login') {
      <app-login-desktop (closeEvent)="closeModal($event)" (changeActionEvent)="changeAction($event)"></app-login-desktop>
    }
    @if (type == 'register') {
      <app-register-desktop (closeEvent)="closeModal($event)" (changeActionEvent)="changeAction($event)"></app-register-desktop>
    }
    @if (type == 'recover') {
      <app-recover-desktop (closeEvent)="closeModal($event)" (changeActionEvent)="changeAction($event)"></app-recover-desktop>
    }
  </div>



</div>